import { Outlet } from "react-router-dom";
import SiteHeader from "@/components/site/SiteHeader";
import SiteFooter from "@/components/site/SiteFooter";
import StickyCTA from "@/components/site/StickyCTA";
import BoardBar from "@/components/site/BoardBar";

export default function SiteLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <SiteHeader />
      <main className="flex-1 pb-16 lg:pb-0">
        <Outlet />
      </main>
      <SiteFooter />
      <StickyCTA />
      <BoardBar />
    </div>
  );
}
